export const DropdownDivider = () => {
  return <div className="dropdown-divider" />;
};
